import { useEffect } from 'react'

import {
  EcommFulfillmentType,
  useValidateCartQuery
} from 'src/apollo/onlineOrdering'
import { Channel } from 'src/public/js/siteUtilities'

import { useCart } from 'public/components/online_ordering/CartContext'
import { useRestaurant } from 'src/shared/components/common/restaurant_context/RestaurantContext'

import { getCartSelectionsSignature } from './cartUtils'

/**
 * Runs validateCart for shipping and refetches when cart selections change.
 * Use in Cart, OrderSection, and FulfillmentSection for shared shipping validation.
 */
export const useValidateCartForShipping = () => {
  const { cart, cartGuid, channel } = useCart()
  const { restaurant, ooRestaurant, ecommSettings } = useRestaurant()

  const shippingEnabled =
    ecommSettings?.fulfillmentConfig?.shippingSettings?.enabled
  const canValidateShipping =
    channel === Channel.ECOMM &&
    shippingEnabled &&
    !!restaurant?.id &&
    !!ooRestaurant?.guid &&
    !!cartGuid

  const {
    data: validateCartData,
    refetch: refetchValidateCart,
    loading: loadingValidateCart,
    error: validateCartError
  } = useValidateCartQuery({
    skip: !canValidateShipping,
    variables: {
      input: {
        siteGuid: restaurant?.id ?? '',
        restaurantGuid: ooRestaurant?.guid ?? '',
        cartGuid: cartGuid ?? '',
        fulfillmentType: EcommFulfillmentType.Shipping
      }
    }
  })

  const cartSelectionsSignature = getCartSelectionsSignature(
    cart?.order?.selections
  )

  useEffect(() => {
    if (canValidateShipping && cartSelectionsSignature !== '') {
      refetchValidateCart()
    }
  }, [canValidateShipping, cartSelectionsSignature, refetchValidateCart])

  const validationProblems =
    validateCartData?.validateCart?.valid === false
      ? validateCartData.validateCart.problems ?? []
      : []
  const shippingValid = validateCartData?.validateCart?.valid !== false
  const isShippingInvalid = validateCartData?.validateCart?.valid === false

  return {
    validateCartData,
    loadingValidateCart,
    validateCartError,
    validationProblems,
    shippingValid,
    isShippingInvalid,
    canValidateShipping,
    refetchValidateCart
  }
}
